import { queryOptions } from '@tanstack/react-query'

import { getTossPaymentWidgetInfo } from './get-toss-payment-widget-info'

export const paymentQueries = {
  all: () => ['payment'],
  tossPayment: () => [...paymentQueries.all(), 'toss'],
  tossPaymentWidgetInfo: (contractId: number) =>
    queryOptions({
      queryKey: [...paymentQueries.tossPayment(), 'widget-info', contractId],
      queryFn: () => getTossPaymentWidgetInfo(contractId),
    }),
}
